import { Controller } from "@hotwired/stimulus"

// Handles dismiss/collapse behavior for awareness banners
export default class extends Controller {
  static targets = ["banner"]

  dismiss() {
    this.element.remove()
  }
}
